import { isCommonResponseSuccessfulV2 } from 'src/mentor/helpers/utilityFunctions'
import { getMPDataWithParams, postMPDataWithoutParams } from 'src/mentor/services'

function getResponseMessage(response, fallbackMessage) {
  return (
    response?.data?.message ||
    response?.response?.data?.message ||
    response?.message ||
    fallbackMessage
  )
}

export async function getMentorPortalVoiceOptions(bookedEventId) {
  if (!bookedEventId) {
    return {
      ok: false,
      message: 'Booked event id is required.',
      routes: [],
    }
  }

  const response = await getMPDataWithParams('/api/secure/mentor/portal-voice/options', {
    bookedEventId,
  })

  if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
    return {
      ok: true,
      routes: response?.data?.data?.routes || [],
      twilioConfigured: !!response?.data?.data?.twilioConfigured,
      bookedEventId: response?.data?.data?.bookedEventId || bookedEventId,
      rawResponse: response,
    }
  }

  return {
    ok: false,
    message: getResponseMessage(response, 'Unable to load portal call routes.'),
    routes: [],
    rawResponse: response,
  }
}

export async function createMentorPortalVoiceBootstrap({
  bookedEventId,
  destinationType,
  uiSurface,
}) {
  if (!bookedEventId || !destinationType) {
    return {
      ok: false,
      message: 'Booked event id and destination type are required.',
    }
  }

  const response = await postMPDataWithoutParams('/api/secure/mentor/portal-voice/bootstrap', {
    bookedEventId,
    destinationType,
    uiSurface,
  })

  if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
    return {
      ok: true,
      accessToken: response?.data?.data?.accessToken,
      requestToken: response?.data?.data?.requestToken,
      renewalToken: response?.data?.data?.renewalToken,
      callSessionId: response?.data?.data?.callSessionId,
      identity: response?.data?.data?.identity,
      expiresInSeconds: response?.data?.data?.expiresInSeconds,
      route: response?.data?.data?.route || {},
      rawResponse: response,
    }
  }

  return {
    ok: false,
    message: getResponseMessage(response, 'Unable to prepare the portal voice call.'),
    rawResponse: response,
  }
}

export async function renewMentorPortalVoiceCall({ interactionId, renewalToken }) {
  if (!interactionId || !renewalToken) {
    return {
      ok: false,
      message: 'interactionId and renewalToken are required.',
    }
  }

  const response = await postMPDataWithoutParams('/api/secure/mentor/portal-voice/renew', {
    interactionId,
    renewalToken,
  })

  if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
    return {
      ok: true,
      interactionId: response?.data?.data?.interactionId || interactionId,
      callExpiresAt: response?.data?.data?.callExpiresAt,
      callTimeLimitSeconds: response?.data?.data?.callTimeLimitSeconds,
      maxCallDurationSeconds: response?.data?.data?.maxCallDurationSeconds,
      renewalIncrementSeconds: response?.data?.data?.renewalIncrementSeconds,
      renewalAllowed: !!response?.data?.data?.renewalAllowed,
      renewalCount: response?.data?.data?.renewalCount || 0,
      renewalToken: response?.data?.data?.renewalToken,
      remainingSeconds: response?.data?.data?.remainingSeconds,
      rawResponse: response,
    }
  }

  return {
    ok: false,
    message: getResponseMessage(response, 'Unable to extend the portal voice call.'),
    rawResponse: response,
  }
}
